import { Injectable, NgZone } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { ServiceBase } from './base.service';
import { User } from '../models/usuario.model';
import { AuthService } from './auth.service';
import { Data } from '../providers/data';
import { Observable } from 'rxjs';

@Injectable()
export class OrderService {
  constructor(
    public http: HttpClient,
    public serviceBase: ServiceBase,
    public authService: AuthService,
    public data: Data
  ) {}

  urlService = this.serviceBase.getUrlApi('v1/order');

/*   obtenerTipos(): Observable<any> {
    return this.http.get<any>(`${this.urlService}types`).pipe(
      map((response) => response),
      catchError(this.serviceBase.handleError)
    );
  }

  prestacionDetall(orderId): Observable<any> {
    return this.http.get<any>(`${this.urlService}detail/${orderId}`).pipe(
      map((response) => response),
      catchError(this.serviceBase.handleError)
    );
  }
 */

nombreArchivos(ordenId): Observable<any>{
  return this.http.get<any>(`${this.urlService}fileNames/${ordenId}`)
  .pipe(
    map((response) => response ),
    catchError(this.serviceBase.handleError)
  );
}

downloadFile(fileName): Observable<any>{
  return this.http.get(`${this.urlService}file/${fileName}`, {
    responseType: 'blob'
  })
  .pipe(
    map((res) => res/*{
       let data = {
                     image: new Blob([res]),
                     filename: nombreArchivo
                  };
    return data ;
  }*/),
    catchError(this.serviceBase.handleError)
  );
}


  update(orderId, files, benefitId): Observable<any> {
    const url = `${this.urlService}`;

    const formData: FormData = new FormData();

    formData.append(
      'data',
      JSON.stringify({
        orderId: orderId,
        benefitId: benefitId
      })
    );

    if (files) {
      for (let i = 0; i < files.length; i++) {
        formData.append(
          files[i].name,
          files[i]
        );
      }
    }

    return this.http
      .put<any>(url, formData)
      .pipe(
        map((response) => response),
        catchError(this.serviceBase.handleError)
      );
  }


}
